export default "__VITE_ASSET__4IAKAkR0__"